const applyFilter = root => {
  const input = root.querySelector('[data-filter-list-input]');
  if (!input) return;

  const query = input.value.trim().toLowerCase();
  let visible = 0;

  root.querySelectorAll('[data-filter-list-item]').forEach(item => {
    const value = (item.dataset.filterValue || item.textContent || '').toLowerCase();
    const match = value.includes(query);
    item.hidden = !match;
    if (match) visible += 1;
  });

  const empty = root.querySelector('[data-filter-list-empty]');
  if (empty) empty.hidden = visible > 0;
};

document.addEventListener('input', event => {
  const root = event.target.closest('[data-filter-list]');
  if (root) applyFilter(root);
});

export default {
  FilterList: {
    mounted() {
      applyFilter(this.el);
    },
  },
};
